import { ManageAccountCardProps } from '@tryhackme/thm-ui-components';

import Pathways from 'src/images/svgs/manage-account/pathways.min.svg';
import AttackBox from 'src/images/svgs/manage-account/attack-box.min.svg';
import FasterMachines from 'src/images/svgs/manage-account/faster-machines.min.svg';
import PremiumContent from 'src/images/svgs/manage-account/premium-content.min.svg';

import { RoadmapType } from './roadmap.types';

export const ROADMAP_SWITCH_OPTIONS: { id: RoadmapType; value: string }[] = [
  { id: 'premium', value: 'Premium Roadmap' },
  { id: 'free', value: 'Free Roadmap' },
];

export const ROOM_CODES = {
  cyberBasics: [
    'introtooffensivesecurity',
    'defensivesecurity',
    'careersincyber',
    'securityprinciples',
    'cybergovernanceregulation',
    'cyberkillchainzmt',
  ],
  fundementals: [
    'linuxfundamentalspart1',
    'pythonbasics',
    'commonattacks',
    'whatisnetworking',
    'networkservices',
    'networkservices2',
    'httpindetail',
    'dnsindetail',
    'howwebsiteswork',
    'puttingitalltogether',
  ],
  securityAnalyst: [
    'jrsecanalystintrouxo',
    'introductoryroomdfirmodule',
    'introtoirandim',
    'introtosiem',
    'introtoendpointsecurity',
    'introtodetectionengineering',
    'trafficanalysisessentials',
    'cyberthreatintel',
    'threatinteltools',
    'phishingemails1tryoe',
  ],
  pentester: [
    'pentestingfundamentals',
    'redteamfundamentals',
    'redteamengagements',
    'activerecon',
    'passiverecon',
    'furthernmap',
    'metasploitintro',
  ],
  securityEngineer: [
    'securityengineerintro',
    'introwebapplicationsecurity',
    'sdlc',
    'introtocontainerisation',
    'introtodockerk8pdqk',
    'introtopipelineautomation',
    'winadbasics',
  ],
};

export const featureCards: ManageAccountCardProps[] = [
  {
    title: 'Guided Paths',
    description: 'Access structured learning paths',
    size: 'small',
    image: {
      src: Pathways,
    },
  },
  {
    title: 'AttackBox',
    description: 'Hack machines all through your browser',
    size: 'small',
    image: {
      src: AttackBox,
    },
  },
  {
    title: 'Faster Machines',
    description: 'Get private VPN servers & faster machines',
    size: 'small',
    image: {
      src: FasterMachines,
    },
  },
  {
    title: 'Premium Content',
    description: 'Unlimited access to all content on TryHackMe ',
    size: 'small',
    image: {
      src: PremiumContent,
    },
  },
];

export enum RoadmapTypes {
  PREMIUM_ROADMAP = 'premium',
  FREE_ROADMAP = 'free',
}
